{
  "appName": "1010ez Health Care Application form",
  "entryFile": "./app-entry.jsx",
  "entryName": "hca",
  "rootUrl": "/forms/10-10ez/apply-va-healthcare",
  "productId": "49610634-597e-49c1-b11a-db67f35f437b",
  "datadog": {
    "applicationId": "9d5155fd-8623-4bc9-8580-ad8ec2cdd7fa",
    "clientToken": "pub20bf1f8aaef56d8c0100b0a65601a702",
    "service": "10-10ez",
    "toggleName": "hcaBrowserMonitoringEnabled",
    "sessionReplaySampleRate": 100
  }
}
